import { render } from "./CommentIcon.vue?vue&type=template&id=4f1ea9ec"
import script from "./CommentIcon.vue?vue&type=script&lang=js"
export * from "./CommentIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__